import { useLocation } from '@tanstack/react-router'
import { LOCALES, LOCALE_NAMES, type Locale, localePath } from '../i18n'
import { useLocale } from './use-locale'

export function LocaleSwitch() {
  const { locale, t, basePath } = useLocale()
  const { searchStr } = useLocation()
  return (
    <label className="locale-switch">
      <svg className="locale-switch__globe" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3Z" />
      </svg>
      {/* select の幅は一番長い選択肢で決まるので、見せる文字は別に置いて幅を今の言語名に合わせる */}
      <span className="locale-switch__name" aria-hidden="true">
        {LOCALE_NAMES[locale]}
      </span>
      <select
        className="locale-switch__select"
        aria-label={t.nav.language}
        value={locale}
        onChange={(e) => {
          // 言語の切り替えはフルリロードにして、lang 属性と SSR の head を確実に入れ替える
          window.location.assign(localePath(e.target.value as Locale, basePath) + (searchStr ?? ''))
        }}
      >
        {LOCALES.map((l) => (
          <option key={l} value={l} lang={l}>
            {LOCALE_NAMES[l]}
          </option>
        ))}
      </select>
      <svg className="locale-switch__caret" viewBox="0 0 12 12" aria-hidden="true">
        <path d="M3 4.5 6 7.5 9 4.5" />
      </svg>
    </label>
  )
}
